import * as React from "react"
const Emerging2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#BDDEFF"
      d="M13.901 2.018c2.526 0 4.51 0 6.058.208 1.587.213 2.846.66 3.836 1.649.99.99 1.436 2.249 1.65 3.836.207 1.549.207 3.532.207 6.058v.132c0 2.526 0 4.51-.208 6.058-.213 1.587-.66 2.846-1.65 3.836-.989.99-2.248 1.436-3.835 1.65-1.549.207-3.532.207-6.058.207h-.132c-2.526 0-4.51 0-6.058-.208-1.587-.213-2.847-.66-3.836-1.65-.99-.989-1.436-2.248-1.65-3.835-.208-1.549-.207-3.532-.207-6.058v-.131c0-2.526 0-4.51.208-6.06.213-1.586.66-2.846 1.649-3.835.99-.99 2.249-1.436 3.836-1.65 1.549-.208 3.533-.207 6.059-.207h.131Zm-5.83 12.105a.865.865 0 0 0-.865.865V19.6a.864.864 0 1 0 1.73 0v-4.612a.866.866 0 0 0-.866-.865Zm5.764-6.917a.864.864 0 0 0-.864.864V19.6a.864.864 0 1 0 1.728 0V8.07a.864.864 0 0 0-.864-.864Zm5.765 4.611a.864.864 0 0 0-.865.865V19.6a.864.864 0 1 0 1.729 0v-6.918a.864.864 0 0 0-.864-.865Z"
    />
  </svg>
)
export default Emerging2
